<template>
<div>
  <!-- 头部区域 -->
  <ShareInfo :share-info="shareData" />
  <GCHeaderRank v-if="data.tipShow" :webapp-link="data.routerLink" />
  <div class="calendar">
    <div class="calendar_bg"></div>
    <div class="calendar-list">
      <div 
        v-for="item in calendarList" 
        :class="['calendar-item', item.status ? 'no-filter' : '']"
        @click="goDetail(item)"
      >
        <div class="bg" :style="{'background-image': 'url(https://static.mingchu.co/webapp/index2024/calendar/'+ (+item.month) + '.png)'}"></div>
        <div class="month-tag"><span class="ft_bm">{{ +item.month }}</span>月</div>
        <div class="status">{{ item.status === 0 ? '未开放' : '已开放' }}</div>
      </div>
    </div>
    <div class="footer">MINGCHU APP</div>
  </div>
</div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import utils from '@/utils/utils'
// import { checkloginCallback } from '@/utils/index'
// import { superLink } from '@/utils/index'
import GCHeaderRank from '@/components/gc-header-rank'

import ShareInfo from '@/components/shareInfo'
import { Toast } from 'vant'

const calendarList = ref([
  { month: '01', date: '2025-01-01', status: 0, url: '/articlesview?id=5367' },
  { month: '02', date: '2025-02-01', status: 0, url: '/articlesview?id=6535' },
  { month: '03', date: '2025-03-01', status: 0, url: '/articlesview?id=6621' },
  { month: '04', date: '2025-04-01', status: 0, url: '/articlesview?id=6665' },
  { month: '05', date: '2025-05-01', status: 0, url: '/articlesview?id=4700' },
  { month: '06', date: '2025-06-01', status: 0, url: '/articlesview?id=4704' },
  { month: '07', date: '2025-07-01', status: 0, url: '/articlesview?id=6850' },
  { month: '08', date: '2025-08-01', status: 0, url: '/articlesview?id=4980' },
  { month: '09', date: '2025-09-01', status: 0, url: '/articlesview?id=5088' },
  { month: '10', date: '2025-10-01', status: 0, url: '/articlesview?id=5155' },
  { month: '11', date: '2025-11-01', status: 0, url: '/articlesview?id=5238' },
  { month: '12', date: '2025-12-01', status: 0, url: '/articlesview?id=5339' }
])
const router = useRouter()
const shareData = ref({
  share_title: '2025 厨师节气日历',
  share_desc: '「名厨 MINGCHU」节气专题精选更多灵感激发你的创作激情',
  share_link: location.href,
  share_img: 'https://static.mingchu.co/webapp/index2024/minishare/calendar.png'
})
const data = reactive({
  tipShow: true,
  routerLink: '/2025chef-calendar',
})

const goDetail = (item) => {
  if (item.status === 0) {
    Toast('当月专题未开放，敬请期待!')
    return
  }

  router.push(item.url)

  // if (utils.is_mini()) {
  //   const urlRes= encodeURIComponent(item.url)
  //   // 小程序
  //   utils.goMiniPage(`pages/redirectUrl/main?urls=${urlRes}`) // 通过小程序方式跳转至 webview 页面
  //   return
  // }

  // if (utils.isGteatChefbrowser()) {
  //   // 名厨浏览器
  //   router.push(item.url)
  //   return
  // }
  // const data = `{
  //   "des": "h5", 
  //   "skuid": "",
  //   "link": ""
  // }`

  // superLink(data)
}

onMounted(async () => {
  // 计算当前年份，当前月份
  const nowDate = new Date().getTime()

  const temp = calendarList.value
  temp.forEach((item) => {
    const curDate = new Date(`${item.date} 00:00:00`).getTime()
    if (nowDate > curDate) {
      item.status = 1
    }
  })

  if (utils.isGteatChefbrowser()) {
    data.tipShow = false
  } else if (utils.is_mini()) {
    data.tipShow = false
  } else {
    data.tipShow = true
  }
  // 非名厨浏览器和小程序就隐藏
  const minires = utils.getQueryVariable('token') // 判断是不是在小程序内，隐藏顶部拉起 app 的条
  if (minires) { data.tipShow = false }
  const appres = await utils.getAuth() // 判断是否在app内，隐藏顶部app提示条
  if (appres !== 0) { 
    data.tipShow = false 
  }
})
</script>

<style lang="scss" scoped>
.calendar {
  width: 100vw;
  height: rem(1560);
  background-color: #1C1C1E;

  .calendar_bg {
    width: 100%;
    height: rem(369);
    background: url('https://static.mingchu.co/webapp/index2024/calendar/calendar_bg.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  &-list {
    margin-top: rem(-95);
  }

  &-item {
    width: rem(343);
    height: rem(84);
    border-radius: rem(8);
    margin: 0 auto rem(10);
    position: relative;
    background-size: contain;

    .bg {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      background-size: contain;
      filter: grayscale(.9);
    }

    .month-tag {
      position: absolute;
      width: rem(32);
      height: rem(20);
      line-height: rem(20);
      text-align: center;
      color: #fff;
      background-color: #E8BB3C;
      border-radius: rem(3);
      font-weight: 500;
      left: rem(20);
      font-size: rem(14);
    }
    .status {
      width: rem(60);
      height: rem(29);
      line-height: rem(29);
      text-align: center;
      color: #000;
      background: rgba(255, 255, 255, 0.86);
      border-radius: rem(4);
      position: absolute;
      right: rem(20);
      top: 50%;
      transform: translateY(-50%);
      font-size: rem(14);
    }

    &.no-filter .bg {
      filter: none;
    }
  }

  .footer {
    font-size: rem(16);
    color: #666;
    text-align: center;
    margin-top: rem(90);
  }
}
</style>